import { JSX } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export default function PDFIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon width="12" height="13" viewBox="0 0 12 13" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.6667 0.5H1.33333C0.6 0.5 0 1.1 0 1.83333V11.1667C0 11.9 0.6 12.5 1.33333 12.5H10.6667C11.4 12.5 12 11.9 12 11.1667V1.83333C12 1.1 11.4 0.5 10.6667 0.5ZM4.33333 6.16667C4.33333 6.7 3.86667 7.16667 3.33333 7.16667H2.66667V8.5H1.66667V4.5H3.33333C3.86667 4.5 4.33333 4.96667 4.33333 5.5V6.16667ZM7.66667 7.5C7.66667 8.03333 7.2 8.5 6.66667 8.5H5V4.5H6.66667C7.2 4.5 7.66667 4.96667 7.66667 5.5V7.5ZM10.3333 5.5H9.33333V6.16667H10.3333V7.16667H9.33333V8.5H8.33333V4.5H10.3333V5.5ZM6 5.5H6.66667V7.5H6V5.5ZM2.66667 5.5H3.33333V6.16667H2.66667V5.5Z"
        fill={props.fill}
      />
    </SvgIcon>
  );
}
